import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useMsal, useIsAuthenticated, useAccount, } from '@azure/msal-react'
import { EventType } from '@azure/msal-browser'
import { loginRequest } from 'authConfig'
import { Helmet } from 'react-helmet';
import {
    AccessImg,
    BodyRightSide,
    ButtonNotify,
    Container,
    FooterRightSide,
    ImgFooter,
    ImgNotify,
    Line,
    MainLeft,
    MainRight,
    MainText,
    MainTitle,
    OneProduct,
    Section,
    SubTitle,
    SubWrapperLeft,
    TextAccount,
    WrapperLeft,
    WrapperRight,
    ContainerLogo
} from 'pages/Login/styles'
import { Link } from 'react-router-dom'
import { ROUTES_NAMES } from '../../constants/name.routes'
import UserServices from 'services/User'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { AuthenticationAction } from 'types/autentication'
import AuthenticationActions from 'actions/Authentication'
import { RootReducerState } from 'types/global'
import { AuthenticationReducer } from 'types/autentication'
import { Alert } from 'components/Modals/Alert'
import { IconError } from 'components/NavBar/svg'
import { SubTitleText, TitleText } from 'pages/NotifyEvent/styles'
import { useIsMobileScreen } from 'hooks/useMediaQuery'
import { isChristmas } from 'helper/date'
import { LogoChristmasLogin, LogoLogin } from 'pages/Login/svg'
import { CrxIcon,CrxHeading } from '@cortex/cortex-core'

const Login: React.FC = () => {
    const isMobile = useIsMobileScreen()
    const navigate = useNavigate()
    let location = useLocation()
    const isAuthenticated = useIsAuthenticated()

    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )

    const authenticationDispatch: Dispatch<AuthenticationAction> = useDispatch<Dispatch<AuthenticationAction>>()
    const { instance, accounts } = useMsal()

    const account = useAccount(accounts[0])

    const [showMessage, setShowMessage] = useState(false)

    const [message, setMessage] = useState(undefined)


    /**
     * Evento de callback chamado a primeira vez apo´s login bem sucessido
     */
    /*
    instance.addEventCallback((message: any) => {
        const azureToken = sessionStorage.getItem('AZURE_AD_ACCESS_TOKEN')
        if (message.eventType === EventType.LOGIN_SUCCESS && !azureToken) {
            authenticationUser(message.payload)
         }
    })
    */
    /**
     * Função para armazaenar o token azure e gerar token jwt
     * @param payload 
     * @param redirect 
     */
    const authenticationUser = (payload: any, redirect: boolean = false) => {

        sessionStorage.setItem('AZURE_AD_ACCESS_TOKEN', payload.accessToken)
        AuthenticationActions.setDataAzure(authenticationDispatch, payload)
        UserServices.getAuthenticationUser(payload.accessToken).then(async (response) => {

            let json = await response.json()

            AuthenticationActions.setDataJwt(authenticationDispatch, json.data)
            AuthenticationActions.showHeader(authenticationDispatch, true)
            sessionStorage.setItem('JWT_TOKEN', json.data.tokenJwt)

            if (json.message && !authenticationSelector.jwtAccessTokenExpired)
                AuthenticationActions.setTokenJwtExpired(authenticationDispatch, true, json)
            /*
            if(redirect){
                window.location.href = '/'
            }
            */
        }).catch((err) => {
            if (err && !authenticationSelector.jwtAccessTokenExpired)
                AuthenticationActions.setTokenJwtExpired(authenticationDispatch, true, err)
        })
    }
    /**
     * Redireciona para tela de iniciar atraves do botão Notificar
     */
    const handleClick = () => {
        navigate(ROUTES_NAMES.notifyEvent)
    }

    /**
     * Fecha o modal com mesagem de alerta
     */
    const closeMessage = () => {
        setShowMessage(false)
    }
    /**
     * Redirecionamento para o login via AzureAD
     */
    const handleLogin = () => {
        instance
            .loginPopup(loginRequest)
            .then(function (loginResponse) {
                authenticationUser(loginResponse)
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    useEffect(() => {
        if (process.env.REACT_APP_CYPRESS_AUTHENTICATED === 'true') {
            sessionStorage.setItem('test.cypress.authenticated', 'true')
            sessionStorage.setItem('test.cypress.profile', process.env.REACT_APP_CYPRESS_PROFILE)
        }
        if (authenticationSelector.showHeader)
            AuthenticationActions.showHeader(authenticationDispatch, false)
    }, [])

    useEffect(() => {

    }, [location]);

    useEffect(() => {
        if (authenticationSelector.messageAuthentication) {
            setShowMessage(true)
            setMessage(authenticationSelector.messageAuthentication)
        }
    }, [authenticationSelector.messageAuthentication]);

    return (
        <Container>

            <Alert
                isOpen={showMessage as boolean}
                handleCloseModal={closeMessage as any}
                labelButtomClose={`Fechar`}
            >
                <div className='justify-center flex p-1'>
                    <IconError></IconError>
                </div>
                <TitleText className={'text-red-500 text-xl font-semibold justify-center flex'}>
                    {message && message.title}
                </TitleText>
                <div className='justify-center flex'>
                    <SubTitleText >
                        <p>{message && message.message}</p>
                    </SubTitleText>
                </div>
            </Alert>


            <WrapperLeft>
                <SubWrapperLeft>
                    <MainLeft>
                        <AccessImg
                            src={'/svg/accessImg.svg'}
                            alt="Acecsar Sistema"
                        />
                        <MainTitle>Sistema de Gestão de</MainTitle>
                        <SubTitle>
                            Notificação de incidentes e Eventos Adversos
                        </SubTitle>
                        <MainText>
                            Construindo uma cultura de segurança <br />
                            proativa, fortalecemos a segurança do paciente
                            <br />
                            nos nossos serviços, implantando barreiras para
                            <br />a prevenção de novos incidentes.
                            <br /> Sua notificação é muito importante!
                        </MainText>
                    </MainLeft>
                </SubWrapperLeft>
            </WrapperLeft>
            <WrapperRight>
                <MainRight>
                    <BodyRightSide>
                        <Section>
                            <ContainerLogo>
                                {!isChristmas() ? (<LogoLogin />) : (<LogoChristmasLogin />)}
                            </ContainerLogo>
                            <span className='mb-24 mt-4 md:hidden block text-xs text-[#005EB8]'>Sistema de Gestão de Notificação de Incidentes e Eventos Adversos</span>
                            <ButtonNotify className='md:mt-24' onClick={handleClick}>
                                Abrir uma nova notificação.
                            </ButtonNotify>
                            <TextAccount className='md:block hidden'>
                                Possui uma conta?{' '}
                                <Link to="#" onClick={handleLogin} className='text-[#005EB8] underline font-bold'>
                                    Faça o seu login aqui
                                </Link>
                            </TextAccount>
                        </Section>
                    </BodyRightSide>
                    <FooterRightSide>
                        {/* <ImgFooter
                            className='w-[280px] md:w-[390px] '
                            src={'/svg/loginLogos.svg'}
                            alt="Logo Segurança do Paciente"
                        /> */}
                    </FooterRightSide>
                {/* Componente CortexDS aplicado */}
                    {/* <CrxIcon icon="NpsLikeLine" size="lg" />
                    <CrxHeading
                    size="2xl"
                    tag="h1"
                    >
                    CortexDs
                    </CrxHeading> */}
                    </MainRight>
            </WrapperRight>
        </Container>
    )
}

export { Login }
